import keywordInASubheader from '#assets/keyword-in-a-subheader.png'

export const Image = ({ src, ...props }) => {
  return <img src={src} {...props} />
}

export const IMAGES = {
  KEYWORD_IN_A_SUBHEADER: keywordInASubheader,
}
